// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vert-card-store {
    box-sizing: border-box;
}
.vert-card-store-wrapper {
    padding: var(--spacing-small);
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 20, 0.12);
    align-items: center;
    min-height: 140px;
}
@media screen and (max-width: 768px) {
    .vert-card-store-wrapper {
        gap: var(--spacing-extra-small);
        align-items: start;
    }
    
    .vert-card-store .vert-card-store-wrapper .vert-card-store-box-image, .vert-card-store .vert-card-store-wrapper .vert-card-store-box-content {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }
}


.vert-card-store-image {
    align-items: center;
    justify-content: center;
    width: 100%;
}
.vert-card-store-avatar {
    width: auto;
    padding-top: 100%;
    background-size: 70%; 
    background-position: center center;
    background-repeat: no-repeat;
    border: solid 1px var(--color-neutral-light-darker);
    border-radius: 50%;
}
@media screen and (max-width: 768px) {
    .vert-card-store-image {
        justify-content: start;
    }
    .vert-card-store-avatar {
        background-size: cover;
        width: 44px;
        height: 44px;
        padding-top: 0px;
    }
}

.vert-card-store-name, .ant-typography.vert-title.ant-typography-type-default.vert-card-store-name {
    font-size: var(--font-paragraph);
    color: var(--color-neutral-dark);
    font-weight: 600;
    line-height: var(--font-paragraph-line);
    font-family: var(--font-family);
    margin-bottom: calc(var(--spacing-extra-small) / 2);
}

.vert-card-store-stock, .ant-typography.vert-paragraph.ant-typography-type-default.vert-card-store-stock  {
    font-size: var(--font-paragraph);
    font-weight: 500;
    color: var(--color-neutral-dark);
    line-height: var(--font-paragraph-line);
    font-family: var(--font-family);
    margin-bottom: var(--spacing-extra-small);
}
@media screen and (max-width: 768px) {
    .vert-card-store-name, .ant-typography.vert-title.ant-typography-type-default.vert-card-store-name {
        font-size: var(--font-small);
        line-height: var(--font-small-line);
    }
    .vert-card-store-stock, .ant-typography.vert-paragraph.ant-typography-type-default.vert-card-store-stock {
        font-size: var(--font-small);
        line-height: var(--font-small-line);
    }
}
.vert-card-store-link, .vert-button.ant-btn.ant-btn-link.vert-card-store-link {
    font-weight: 500;
    color: var(--color-detached);
    font-size: var(--font-paragraph);
    font-family: var(--font-family);
}
@media screen and (max-width: 768px) {
    .vert-card-store-link, .vert-button.ant-btn.ant-btn-link.vert-card-store-link {
        font-size: var(--font-small);
    }
}

.StoreItem {
    padding: 4px 8px;
    box-sizing: border-box;
}
.StoreItem-box {
    padding: var(--spacing-small);
    border-radius: var(--border-radius-secondary);
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 20, 0.12);
    display: grid;
    align-items: center;
    grid-template-columns: auto 1fr;
    gap: var(--spacing-regular);
}
@media screen and (max-width: 1440px) {
    .StoreItem-box {
        align-items: center !important;
        height: 130px;
    }
}
@media screen and (max-width: 1024px) {
    .StoreItem-box {
        align-items: center !important;
        height: 152px;
    }
}
@media screen and (max-width: 768px) {
    .StoreItem-box {
        gap: var(--spacing-small);
        align-items: start;
        height: 100px;
    }
}
@media screen and (max-width: 576px) {
    .StoreItem-box {
        align-items: center !important;
        height: 110px;
    }
}
@media screen and (max-width: 425px) {
    .StoreItem-box {
        align-items: center !important;
        height: 130px;
    }
}
.StoreItem-figure {
    width: 80px;
    height: 80px;
    border-radius: 100%;
    border: solid 1px var(--storeFigureBorderColor);
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}
@media screen and (max-width: 768px) {
    .StoreItem-figure {
        width: 44px;
        height: 44px;
    }
}

.StoreItem-figure img {
    max-height: 60px;
    max-width: 60px;
}
@media screen and (max-width: 768px) {
    .StoreItem-figure img {    
        max-height: 40px;
        max-width: 40px;
    }
}
.StoreItem-name {
    font-size: var(--font-paragraph);
    color: var(--color-neutral-dark);
    font-weight: 600;
    line-height: var(--font-paragraph-line);
    font-family: var(--font-family);
    margin-bottom: calc(var(--spacing-extra-small) / 2);
}
.StoreItem-stock {
    font-size: var(--font-paragraph);
    font-weight: 500;
    color: var(--color-neutral-dark);
    line-height: var(--font-paragraph-line);
    font-family: var(--font-family);
    margin-bottom: var(--spacing-extra-small);
}
@media screen and (max-width: 768px) {
    .StoreItem-stock {
        font-size: var(--font-small);
        font-weight: 500;
        color: var(--color-neutral-dark);
        line-height: var(--font-small-line);
        font-family: var(--font-family);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/StoresShowcase/components/StoreCarousel/components/StoreItem/style.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;AACA;IACI,6BAA6B;IAC7B,gDAAgD;IAChD,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI;QACI,+BAA+B;QAC/B,kBAAkB;IACtB;;IAEA;QACI,4BAA4B;QAC5B,6BAA6B;IACjC;AACJ;;;AAGA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,kCAAkC;IAClC,4BAA4B;IAC5B,mDAAmD;IACnD,kBAAkB;AACtB;AACA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;QACtB,WAAW;QACX,YAAY;QACZ,gBAAgB;IACpB;AACJ;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,gBAAgB;IAChB,uCAAuC;IACvC,+BAA+B;IAC/B,mDAAmD;AACvD;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,gCAAgC;IAChC,uCAAuC;IACvC,+BAA+B;IAC/B,yCAAyC;AAC7C;AACA;IACI;QACI,4BAA4B;QAC5B,mCAAmC;IACvC;IACA;QACI,4BAA4B;QAC5B,mCAAmC;IACvC;AACJ;AACA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,gCAAgC;IAChC,+BAA+B;AACnC;AACA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,6BAA6B;IAC7B,6CAA6C;IAC7C,gDAAgD;IAChD,aAAa;IACb,mBAAmB;IACnB,+BAA+B;IAC/B,2BAA2B;AAC/B;AACA;IACI;QACI,8BAA8B;QAC9B,aAAa;IACjB;AACJ;AACA;IACI;QACI,8BAA8B;QAC9B,aAAa;IACjB;AACJ;AACA;IACI;QACI,yBAAyB;QACzB,kBAAkB;QAClB,aAAa;IACjB;AACJ;AACA;IACI;QACI,8BAA8B;QAC9B,aAAa;IACjB;AACJ;AACA;IACI;QACI,8BAA8B;QAC9B,aAAa;IACjB;AACJ;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,+CAA+C;IAC/C,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI;QACI,gBAAgB;QAChB,eAAe;IACnB;AACJ;AACA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,gBAAgB;IAChB,uCAAuC;IACvC,+BAA+B;IAC/B,mDAAmD;AACvD;AACA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,gCAAgC;IAChC,uCAAuC;IACvC,+BAA+B;IAC/B,yCAAyC;AAC7C;AACA;IACI;QACI,4BAA4B;QAC5B,gBAAgB;QAChB,gCAAgC;QAChC,mCAAmC;QACnC,+BAA+B;IACnC;AACJ","sourcesContent":[".vert-card-store {\n    box-sizing: border-box;\n}\n.vert-card-store-wrapper {\n    padding: var(--spacing-small);\n    box-shadow: 0px 1px 4px 0px rgba(0, 0, 20, 0.12);\n    align-items: center;\n    min-height: 140px;\n}\n@media screen and (max-width: 768px) {\n    .vert-card-store-wrapper {\n        gap: var(--spacing-extra-small);\n        align-items: start;\n    }\n    \n    .vert-card-store .vert-card-store-wrapper .vert-card-store-box-image, .vert-card-store .vert-card-store-wrapper .vert-card-store-box-content {\n        padding-left: 0px !important;\n        padding-right: 0px !important;\n    }\n}\n\n\n.vert-card-store-image {\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n}\n.vert-card-store-avatar {\n    width: auto;\n    padding-top: 100%;\n    background-size: 70%; \n    background-position: center center;\n    background-repeat: no-repeat;\n    border: solid 1px var(--color-neutral-light-darker);\n    border-radius: 50%;\n}\n@media screen and (max-width: 768px) {\n    .vert-card-store-image {\n        justify-content: start;\n    }\n    .vert-card-store-avatar {\n        background-size: cover;\n        width: 44px;\n        height: 44px;\n        padding-top: 0px;\n    }\n}\n\n.vert-card-store-name, .ant-typography.vert-title.ant-typography-type-default.vert-card-store-name {\n    font-size: var(--font-paragraph);\n    color: var(--color-neutral-dark);\n    font-weight: 600;\n    line-height: var(--font-paragraph-line);\n    font-family: var(--font-family);\n    margin-bottom: calc(var(--spacing-extra-small) / 2);\n}\n\n.vert-card-store-stock, .ant-typography.vert-paragraph.ant-typography-type-default.vert-card-store-stock  {\n    font-size: var(--font-paragraph);\n    font-weight: 500;\n    color: var(--color-neutral-dark);\n    line-height: var(--font-paragraph-line);\n    font-family: var(--font-family);\n    margin-bottom: var(--spacing-extra-small);\n}\n@media screen and (max-width: 768px) {\n    .vert-card-store-name, .ant-typography.vert-title.ant-typography-type-default.vert-card-store-name {\n        font-size: var(--font-small);\n        line-height: var(--font-small-line);\n    }\n    .vert-card-store-stock, .ant-typography.vert-paragraph.ant-typography-type-default.vert-card-store-stock {\n        font-size: var(--font-small);\n        line-height: var(--font-small-line);\n    }\n}\n.vert-card-store-link, .vert-button.ant-btn.ant-btn-link.vert-card-store-link {\n    font-weight: 500;\n    color: var(--color-detached);\n    font-size: var(--font-paragraph);\n    font-family: var(--font-family);\n}\n@media screen and (max-width: 768px) {\n    .vert-card-store-link, .vert-button.ant-btn.ant-btn-link.vert-card-store-link {\n        font-size: var(--font-small);\n    }\n}\n\n.StoreItem {\n    padding: 4px 8px;\n    box-sizing: border-box;\n}\n.StoreItem-box {\n    padding: var(--spacing-small);\n    border-radius: var(--border-radius-secondary);\n    box-shadow: 0px 1px 4px 0px rgba(0, 0, 20, 0.12);\n    display: grid;\n    align-items: center;\n    grid-template-columns: auto 1fr;\n    gap: var(--spacing-regular);\n}\n@media screen and (max-width: 1440px) {\n    .StoreItem-box {\n        align-items: center !important;\n        height: 130px;\n    }\n}\n@media screen and (max-width: 1024px) {\n    .StoreItem-box {\n        align-items: center !important;\n        height: 152px;\n    }\n}\n@media screen and (max-width: 768px) {\n    .StoreItem-box {\n        gap: var(--spacing-small);\n        align-items: start;\n        height: 100px;\n    }\n}\n@media screen and (max-width: 576px) {\n    .StoreItem-box {\n        align-items: center !important;\n        height: 110px;\n    }\n}\n@media screen and (max-width: 425px) {\n    .StoreItem-box {\n        align-items: center !important;\n        height: 130px;\n    }\n}\n.StoreItem-figure {\n    width: 80px;\n    height: 80px;\n    border-radius: 100%;\n    border: solid 1px var(--storeFigureBorderColor);\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n@media screen and (max-width: 768px) {\n    .StoreItem-figure {\n        width: 44px;\n        height: 44px;\n    }\n}\n\n.StoreItem-figure img {\n    max-height: 60px;\n    max-width: 60px;\n}\n@media screen and (max-width: 768px) {\n    .StoreItem-figure img {    \n        max-height: 40px;\n        max-width: 40px;\n    }\n}\n.StoreItem-name {\n    font-size: var(--font-paragraph);\n    color: var(--color-neutral-dark);\n    font-weight: 600;\n    line-height: var(--font-paragraph-line);\n    font-family: var(--font-family);\n    margin-bottom: calc(var(--spacing-extra-small) / 2);\n}\n.StoreItem-stock {\n    font-size: var(--font-paragraph);\n    font-weight: 500;\n    color: var(--color-neutral-dark);\n    line-height: var(--font-paragraph-line);\n    font-family: var(--font-family);\n    margin-bottom: var(--spacing-extra-small);\n}\n@media screen and (max-width: 768px) {\n    .StoreItem-stock {\n        font-size: var(--font-small);\n        font-weight: 500;\n        color: var(--color-neutral-dark);\n        line-height: var(--font-small-line);\n        font-family: var(--font-family);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
